<script>
  import { navigate } from "svelte-routing";
  /* Executable code section of the program */
  // import tools
  import { toSingIn, postDataLocal,getCollection, getSpecificDocuments } from "../apis/APIS";
  import { userLocalData } from "../apis/storage";

  // Auxiliary variables
  let email = "";
  let password = "";
  let isEmptyInput = false;
  let isCorrectInfo = true;
  let messageError = "";

  //function auxiliary to login
  const funtionLogIn = () => {
    if (email === "" || password === "") {
      isEmptyInput = true;
    } else {
      toSingIn(email, password)
        .then(async (data) => {
          $userLocalData = await getSpecificDocuments("users","email",email)
          if ($userLocalData[0].userRole === "administrator" || $userLocalData[0].userRole === "coordinator") {
            let events = await getCollection("events");
            postDataLocal("events",events);
          }
        })
        .catch((error) => {
          setTimeout(()=>{
          isCorrectInfo = false;
          messageError = "Invalid login: incorrect email or password.";
          },2000)
        });
    }
  };
  // Function to verify empty inputs
  const getEmptyInput = (input) => {
    if (input === "") {
      isEmptyInput = true;
    } else {
      isEmptyInput = false;
    }
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<body>
  <div class="containerForm">
    <img class="image" src="./Logo.png" alt="NameLogo" />
    {#if !isCorrectInfo}
      <div class="mssError">
        <p>{messageError || "hola"}</p>
      </div>
    {:else if isEmptyInput}
      <div class="mssEmptyInput">
        <p>All fields must be completed.</p>
      </div>
    {/if}
    <form class="loginForm" action="">
      <div class="form-floating">
        <input
          type="email"
          class="form-control floatingPassword"
          placeholder="Email"
          bind:value={email}
          on:blur={() => getEmptyInput(email)}
        />
        <label for="floatingPassword">Email</label>
        <br />
      </div>
      <div class="form-floating">
        <input
          type="password"
          class="form-control floatingPassword"
          placeholder="Password"
          bind:value={password}
          on:blur={() => getEmptyInput(password)}
        />
        <label for="floatingPassword">Password</label>
        <br />
      </div>
      <div class="containerLinkRestablecesPass">
        <a href="/resetPassword">¿You have forgotten your password?</a>
      </div>

      <div id="passwordError" class="error-message"></div>
    </form>
    <div class="button">
      <button class="btnInformation" on:click={() => funtionLogIn()}>
        Login
      </button>
    </div>
  </div>
</body>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 99vh;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #f4f4f4;
  }
  .containerForm {
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    width: 30%;
  }
  .image {
    width: 80%;
    height: auto;
    margin: 15px 0;
  }
  .loginForm {
    margin: 10px 0;
  }
  .floatingPassword {
    margin: 0;
    padding: 0;
  }

  .button {
    display: flex;
    justify-content: center;
  }
  .btnInformation {
    padding: 10px;
    border: 0;
    color: white;
    width: 300px;
    border-radius: 12px;
    font-size: 20px;
    background-color: #ed2824;
  }
  .btnInformation:hover {
    background-color: #ff4d44;
    box-shadow: none;
    transition: ease-in-out 0.5s;
  }

  .error-message {
    color: red;
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 10px;
    display: none;
  }
  .containerLinkRestablecesPass {
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }

  a {
    color: black;
  }
  a:hover {
    color: blue;
  }
  .mssEmptyInput,
  .mssError {
    background-color: #ffe1e8;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff3a3c;
    margin: 10px 0;
  }
  /* /////////Tabletas///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .containerForm {
      width: 50%;
      padding: 40px;
    }
  }
  /* /////////Phones ///////// */
  @media (max-width: 700px) {
    .containerForm {
      width: 90%;
    }
  }

  /* End of the section */
</style>
